import { resolveTenbisPhase, type OrderView, type TenbisOrderPhase, type TenbisStatusAction } from 'shared-models/browser';

const PHASE_LABEL: Record<Exclude<TenbisOrderPhase, 'unknown'>, string> = {
  new: 'ממתינה',
  accepted: 'בהכנה',
  out_for_delivery: 'יצאה',
  canceled: 'בוטלה',
  handled_by_tenbis: 'טופלה ע"י תן ביס',
};

export function tenbisStatusLabel(status: string | null | undefined): string {
  const phase = resolveTenbisPhase(status);
  return phase === 'unknown' ? (status ?? '—') : PHASE_LABEL[phase];
}

// Buttons per phase; the second step reads "נאסף" for a pickup order.
export function visibleTenbisActions(status: string | null | undefined): TenbisStatusAction[] {
  switch (resolveTenbisPhase(status)) {
    case 'new':
      return ['accept'];
    case 'accepted':
      return ['out_for_delivery'];
    default:
      return [];
  }
}

export function tenbisActionLabel(action: TenbisStatusAction, deliveryMethod: OrderView['tenbisDeliveryMethod']): string {
  if (action === 'accept') {
    return 'קבל';
  }
  return deliveryMethod === 'pickup' ? 'נאסף' : 'יצא למשלוח';
}

export function tenbisDeliveryLabel(deliveryMethod: OrderView['tenbisDeliveryMethod']): string {
  return deliveryMethod === 'pickup' ? 'איסוף' : 'משלוח';
}

export function tenbisPaymentLabel(paymentMethod: OrderView['tenbisPaymentMethod']): string | null {
  switch (paymentMethod) {
    case 'tenbis':
      return 'שולם בתן ביס';
    case 'cash':
      return 'מזומן לשליח';
    case 'mixed':
      return 'תשלום מעורב';
    default:
      return null;
  }
}

// Last four digits of the Tenbis id; a pool joiner id ("pool#member") shows the member's digits.
export function tenbisShortId(tenbisOrderId: string | null | undefined): string {
  const digits = (tenbisOrderId ?? '').split('#').pop()?.replace(/\D/g, '') ?? '';
  return digits.slice(-4);
}
